<template>
  <v-container
    class="create-account text-center text-sm-left align-center align-sm-start"
  >
    <h2 class="text-uppercase mb-7 text-center text-lg-left">
      {{ $t("register.createOnlineAccount.title") }}
    </h2>
    <h4 class="mb-8 mb-sm-10 px-2 px-sm-0">
      {{ $t("register.createOnlineAccount.mandatory") }}
    </h4>

    <v-form ref="form" v-model="isValid" v-if="registerData">
      <v-row>
        <v-col cols="12" lg="6" class="pb-0">
          <!-- email-->
          <v-text-field
            v-model.trim="registerData.email"
            :rules="emailRules"
            :label="`${$t('register.createOnlineAccount.usernameLabel')} *`"
            :placeholder="
              $t('register.createOnlineAccount.usernamePlaceholder')
            "
            required
            solo
            elevation="0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pb-5 pb-lg-0 pt-0 pt-lg-4">
          <h5 class="text-left">
            {{ $t("register.createOnlineAccount.usernameWarning") }}
          </h5>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col cols="12" lg="6">
          <!-- password -->
          <v-text-field
            v-model="registerData.password"
            :label="`${$t('register.createOnlineAccount.passwordLabel')} *`"
            :placeholder="
              $t('register.createOnlineAccount.passwordPlaceholder')
            "
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordRules"
            @click:append="toggleShowPassword"
            required
            solo
            elevation="0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          <!-- conferma password -->
          <v-text-field
            v-model="registerData.passwordConfirm"
            :label="
              `${$t('register.createOnlineAccount.confirmPasswordLabel')} *`
            "
            :placeholder="
              $t('register.createOnlineAccount.confirmPasswordPlaceholder')
            "
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordConfirm"
            @click:append="toggleShowPassword"
            required
            solo
            elevation="0"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <!-- <v-container class="pt-0 privacy-terms">
      <v-row no-gutters>
        <v-checkbox
          light
          hide-details
          v-model="personInfos[1].value"
          :value="personInfos[1].personInfoTypeId"
        >
          <template v-slot:label>
            <span>
              {{
                $t(
                  "register.createOnlineAccount.privacy.secondPrivacyDescInitial"
                )
              }}
              <a @click.stop.prevent="goToSalesConditions()">{{
                $t(
                  "register.createOnlineAccount.privacy.secondPrivacyDescFinal"
                )
              }}</a>
            </span>
          </template>
        </v-checkbox>
      </v-row>

      <v-row no-gutters>
        <v-checkbox
          light
          hide-details
          v-model="personInfos[0].value"
          :value="personInfos[0].personInfoTypeId"
        >
          <template v-slot:label>
            <i18n
              path="register.createOnlineAccount.privacy.firstPrivacyDesc"
              tag="span"
            >
              <template v-slot:br><br /></template>
              <template v-slot:link>
                <a
                  role="button"
                  class="go-to-privacy"
                  @click.stop.prevent="goToPrivacy"
                  @mousedown.stop
                  >{{
                    $t(
                      "register.createOnlineAccount.privacy.firstPrivacyDescLink"
                    )
                  }}</a
                >
              </template>
            </i18n>
          </template>
        </v-checkbox>
      </v-row>

      <v-row no-gutters class="pl-8">
        <v-radio-group required light v-model="personInfos[2].value" row>
          <div></div>
          <template v-slot:label>
            <span
              v-html="
                $t('register.createOnlineAccount.privacy.thirdPrivacyDesc')
              "
            ></span
          ></template>
          <v-radio :label="$t('common.yes')" :value="true"></v-radio>
          <v-radio :label="$t('common.no')" :value="false"></v-radio>
        </v-radio-group>
      </v-row>

      <v-row no-gutters class="pl-8">
        <v-radio-group required light v-model="personInfos[3].value" row>
          <template v-slot:label>
            <span
              v-html="
                $t('register.createOnlineAccount.privacy.fourthPrivacyDesc')
              "
            ></span
          ></template>
          <v-radio :label="$t('common.yes')" :value="true"></v-radio>
          <v-radio :label="$t('common.no')" :value="false"></v-radio>
        </v-radio-group>
      </v-row>
    </v-container> -->
    <v-row
      no-gutters
      justify="space-around"
      class="pt-4 pt-md-10 pb-16 pb-md-0"
    >
      <v-btn outlined class="primary--text" depressed x-large @click="goBack()">
        {{ $t("register.createOnlineAccount.back") }}
      </v-btn>
      <v-btn
        color="secondary"
        depressed
        x-large
        :disabled="!isValid"
        @click="submit()"
      >
        {{ $t("register.createOnlineAccount.submit") }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {
  requiredValue,
  isEmail,
  isPasswordMinimumLength
} from "@/validator/validationRules";
import CartService from "~/service/cartService";
import EurospinCustomService from "@/service/eurospinCustomService";
export default {
  props: ["registerData"],
  data() {
    return {
      requiredValue: requiredValue,
      requiredRules: [requiredValue()],
      personInfos: [
        {
          personInfoTypeId: 1,
          value: false
        },
        {
          personInfoTypeId: 2,
          value: false
        },
        {
          personInfoTypeId: 3,
          value: null
        },
        {
          personInfoTypeId: 4,
          value: null
        }
      ],
      showPassword: false,
      isValid: true,
      lazy: false,
      response: {},
      error: false,
      emailRules: [requiredValue("Digitare l'e-mail"), isEmail()],
      passwordRules: [
        requiredValue("Digitare la password"),
        isPasswordMinimumLength()
      ],
      passwordConfirm: [
        v => !!v || "Confermare la password",
        v => v === this.registerData.password || "Le password non coincidono"
      ]
    };
  },
  methods: {
    goToPrivacy() {
      if (this.$platform_is_cordova) {
        window.cordova.InAppBrowser.open("/page/privacy-policy", "_system");
      } else {
        window.open("/page/privacy-policy", "_blank");
      }
    },
    goBack() {
      this.$emit("prev");
    },
    toggleShowPassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword;
    },
    goToSalesConditions() {
      window.open(
        "/page/condizioni-generali-di-acquisto-e-pagamento/",
        "_blank"
      );
    },
    // TODO: da verificare la mappatura dei valori di privacy da inviare
    async submit() {
      let data = this.registerData;
      data.person.personInfos = this.personInfos;
      try {
        this.error = false;
        this.loading = true;
        if (this.$refs.form.validate()) {
          let res = await EurospinCustomService.registerUser(this.registerData);
          console.log(res);
          this.loading = false;
          if (res && !res.errors) {
            await CartService.getCart();
            this.$emit("end");
          } else {
            if (res.errors) {
              this.error = true;
            }
          }
        }
      } catch (response) {
        this.response = response;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
